module.exports = __webpack_public_path__ + "static/img/media-img-desert.165c70e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/media-img-desert.png
// module id = zewW
// module chunks = 0